import { Component, Injector, OnInit } from '@angular/core';
import { ActiveModal, AlertService, ChassisFormHandler, FormFactory, MultiTenantService, TenantModel, TenantService, trans } from '@kaiser-software/chassis-core';
import { WorkLogService } from '../../services/work-log.service';
import { WorkLogModel } from '../../models/work-log.model';

@Component({
    selector: 'app-work-logs-create-modal',
    templateUrl: 'create-work-log.modal.html',
    styleUrls: ['create-work-log.modal.scss']
})
export class CreateWorkLogModal implements OnInit {

    public form: ChassisFormHandler;

    public location: any;

    constructor(
        protected injector: Injector,
        protected modal: ActiveModal,
        protected alertService: AlertService,
        protected workLogService: WorkLogService,
        protected multiTenantService: MultiTenantService,
        protected tenantService: TenantService,
        protected formFactory: FormFactory) {
    }

    ngOnInit() {
        this.modal.set('title', 'Time registration');

        this.loadLocation();

        const model = this.setUpModel();

        this.setUpForm(model);
        this.setModalButtons(model);
    }

    protected setUpModel(): WorkLogModel {
        return this.workLogService.make({
            'hours': 0,
            'minutes': 0,
        });
    }

    protected setUpForm(model: WorkLogModel): ChassisFormHandler {
        return this.form = this.formFactory.create(
            'work_log',
            model
        );
    }

    protected setModalButtons(model: WorkLogModel): void {
        const buttons = this.modal.get<any>('buttons');

        buttons.get('ok').callback = () => {
            const alert = this.alertService.open({
                message: trans('Are you sure you want to add') + ': ' + (model.hours || 0) + ' ' +
                    trans('hours') + ' ' + trans('and') + ' ' + (model.minutes || 0) + ' ' +
                    trans('minutes') + '?',
            });

            alert.result.then((result) => {
                this.form.submit();
            }, (reason) => {

            });
        };
    }

    protected loadLocation(): void {
        const tenantId = Number(this.multiTenantService.getCurrentScope());

        this.tenantService.one(tenantId)
            .subscribe((tenant: TenantModel) => {
                console.log(tenant);
                this.location = tenant;
            })
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/work-logs/modals/create-work-log/create-work-log.modal.ts